import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import BreadCrumb from "app/components/BreadCrumb";
import { AddButton } from "app/components/Button/AddButton";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import { manufacturerModelSaga } from "../../redux/saga";
import { manufacturerModelActions, reducer, sliceKey } from "../../redux/slice";
import DetailsTable from "./DetailsTable";
import ModelDetailsForm from "./ModelDetailsForm";
import { useStyles } from "./styles";

const ModelDetails = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: manufacturerModelSaga,
  });

  useEffect(() => {
    const modelId = Number(id);
    if (!id || Number.isNaN(modelId)) return;
    const timer = window.setTimeout(() => {
      dispatch(manufacturerModelActions.getModelDetails(modelId));
    }, 0);
    return () => window.clearTimeout(timer);
  }, [dispatch, id]);

  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb
              title={t("SIDEBAR.MODEL_PER_MANUFACTURER")}
              subTitle={t("MANUFACTURER_MODELS.DETAILS.TITLE")}
              onBackClick={() =>
                navigate("/system-tables/model-per-manufacturer")
              }
            />
            <ModelDetailsForm />

            <Box className={styles.sectionBar}>
              <Typography className={styles.sectionTitle}>
                {t("MANUFACTURER_MODELS.DETAILS.TECH_SPECS_TITLE")}
              </Typography>
              <AddButton
                label={t("MANUFACTURER_MODELS.DETAILS.ADD_TABLE_ROW")}
              />
            </Box>
            <DetailsTable />
          </Box>
        </Box>
    </Box>
  );
};

export default ModelDetails;
